import { createGlobalStyle } from 'styled-components'

export const ClientGlobalStyles = createGlobalStyle`
  /* Add your global styles here */
`
